// extracted by mini-css-extract-plugin
export default {"field":"ImagesAndCTA_field__MQWqg"};